export const PasswordResetType = {
  reset: "reset",
  find: "find",
}